import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import worldRenderer from '../world_view/renderer.js'
import translate from 'toxilibs/translate.js'
import getUrlParams from 'toxilibs/url_params.js'
import './source_code.js'
import './line_marker.js'
import './challenge_selection.js'
import './tutorial_text.js'
import './mute_button.js'
import './reset_progression_state.js'
import './end_page.js'
import './team_page.js'
import './hour_of_code.js'
import './challenge_data.js'
import './buttons_panel.js'

globalEventBus.on('player lost', function () {

    setTimeout(function () {
        $('#mapContainer').fadeOut(600)
    }, 400)

})


globalEventBus.on('world reset', function () {
    $('#mapContainer').fadeIn(700)
})



globalEventBus.on('application loaded', function () {

    translate.translateHtml()

    worldRenderer.init($('#mapContainer'))

    $(window).resize(globalEventBus.emitter('ui resized'))


    if ('colorblind' in getUrlParams()) {
        $('body').addClass('colorblind')
    }

})

